import {FragmentRowData} from "src/app/model/ReviewData";
import * as React from "react";
import FragmentRow from "src/app/component/review/FragmentRow";

interface FragmentProps {
    data: FragmentRowData[];
}

const Fragment = (props: FragmentProps) => {
    return (
        <div>
            {props.data?.map((fragmentRowData, index) => (
                <FragmentRow data={fragmentRowData} key={index}></FragmentRow>
            ))
            }
        </div>
    )
}

export default Fragment;